"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.is3dIssue = void 0;
const is3dIssue = issue => {
  var _issue$linkedDocument;
  return ((_issue$linkedDocument = issue.linkedDocuments) === null || _issue$linkedDocument === void 0 || (_issue$linkedDocument = _issue$linkedDocument[0]) === null || _issue$linkedDocument === void 0 ? void 0 : _issue$linkedDocument.type) === "TwoDVectorPushpin";
};
exports.is3dIssue = is3dIssue;
//# sourceMappingURL=issueLinkedDocumentsUtils.js.map